import { render, staticRenderFns } from "./tencentcustomaudiences-add-or-update.vue?vue&type=template&id=28f2bd98&"
import script from "./tencentcustomaudiences-add-or-update.vue?vue&type=script&lang=js&"
export * from "./tencentcustomaudiences-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports